import React, { useEffect, useState } from "react";


function Planone() {
console.log("Planone")

  return (
    <div className="container mt-4" style={{ fontFamily: "Poppins" }}>
      <h3
        style={{ fontSize: "18px", fontWeight: 600 }}
        className="mb-4 text-center"
      >
        Subscription Plans
      </h3>

          <button
                className="btn mt-3"
                style={{
                  width: "100%",
                  borderRadius: "12px",
                  fontSize: "14px",
                  fontWeight: 500,
                  padding: "10px",
                  backgroundColor: "#4B7BEC",
                  color: "#fff",
                  border: "none",
                }} 
              >
                Subscribe Now
              </button>
    </div>
  );
}

export default Planone;
